import classes from './Service.module.css';

const Service = () => {
    return (
        <div className={classes.service}>
            <div className={classes.container}>
                <h1 className={classes.pageTitle}>Our Services</h1>
                <p className={classes.pageDescription}>
                    EmpireService provides expert repair services for all major home appliances. 
                    Our skilled technicians ensure quality service and customer satisfaction.
                </p>

                <div className={classes.servicesGrid}>
                    <div className={classes.serviceCard}>
                        <div className={classes.serviceIcon}>🧊</div>
                        <h2>Refrigerator Repair</h2>
                        <p className={classes.serviceDescription}>
                            Professional repair services for all refrigerator types including single door, 
                            double door, side-by-side, and French door models.
                        </p>
                        <ul className={classes.serviceFeatures}>
                            <li>Cooling issues repair</li>
                            <li>Frost problems solution</li>
                            <li>Compressor replacement</li>
                            <li>Gas refilling and leak repair</li>
                            <li>Thermostat and sensor repair</li>
                            <li>Door seal replacement</li>
                        </ul>
                        <div className={classes.serviceBrands}>
                            <h4>Brands We Service:</h4>
                            <span>LG, Samsung, Whirlpool, Godrej, Videocon, Panasonic & more</span>
                        </div>
                        <a href="tel:8879552122" className={classes.bookButton}>Book Service</a>
                    </div>

                    <div className={classes.serviceCard}>
                        <div className={classes.serviceIcon}>🌀</div>
                        <h2>Washing Machine Repair</h2>
                        <p className={classes.serviceDescription}>
                            Complete washing machine repair solutions for front-load, top-load, and semi-automatic models.
                        </p>
                        <ul className={classes.serviceFeatures}>
                            <li>Drum and motor repair</li>
                            <li>Water pump replacement</li>
                            <li>Control board repair</li>
                            <li>Door lock issues</li>
                            <li>Spin and drainage problems</li>
                            <li>Vibration and noise reduction</li>
                        </ul>
                        <div className={classes.serviceBrands}>
                            <h4>Brands We Service:</h4>
                            <span>IFB, Bosch, LG, Samsung, Whirlpool, Panasonic & more</span>
                        </div>
                        <a href="tel:8879552122" className={classes.bookButton}>Book Service</a>
                    </div>

                    <div className={classes.serviceCard}>
                        <div className={classes.serviceIcon}>📦</div>
                        <h2>Microwave Oven Repair</h2>
                        <p className={classes.serviceDescription}>
                            Expert microwave repair services for convection, grill, and solo microwave ovens.
                        </p>
                        <ul className={classes.serviceFeatures}>
                            <li>Heating issues repair</li>
                            <li>Magnetron replacement</li>
                            <li>Turntable problems</li>
                            <li>Control panel repair</li>
                            <li>Door safety issues</li>
                            <li>Power and timer problems</li>
                        </ul>
                        <div className={classes.serviceBrands}>
                            <h4>Brands We Service:</h4>
                            <span>Samsung, LG, Panasonic, Whirlpool, IFB, Bosch & more</span>
                        </div>
                        <a href="tel:8879552122" className={classes.bookButton}>Book Service</a>
                    </div>

                    <div className={classes.serviceCard}>
                        <div className={classes.serviceIcon}>📺</div>
                        <h2>TV Repair</h2>
                        <p className={classes.serviceDescription}>
                            Professional TV repair services for LED, LCD, OLED, and Smart TVs.
                        </p>
                        <ul className={classes.serviceFeatures}>
                            <li>Screen repair and replacement</li>
                            <li>Sound issues repair</li>
                            <li>Power problems solution</li>
                            <li>Software update and installation</li>
                            <li>Connectivity issues repair</li>
                        </ul>
                        <div className={classes.serviceBrands}>
                            <h4>Brands We Service:</h4>
                            <span>Samsung, LG, Sony, Panasonic, VU, MI & more</span>
                        </div>
                        <a href="tel:8879552122" className={classes.bookButton}>Book Service</a>
                    </div>

                    <div className={classes.serviceCard}>
                        <div className={classes.serviceIcon}>❄️</div>
                        <h2>AC Repair</h2>
                        <p className={classes.serviceDescription}>
                            Expert AC repair services for window, split, and inverter ACs.
                        </p>
                        <ul className={classes.serviceFeatures}>
                            <li>Cooling issues repair</li>
                            <li>Gas refilling and leak repair</li>
                            <li>Compressor replacement</li>
                            <li>Thermostat and sensor repair</li>
                            <li>Drainage and water leakage issues</li>
                        </ul>
                        <div className={classes.serviceBrands}>
                            <h4>Brands We Service:</h4>
                            <span>LG, Samsung, Whirlpool, Voltas, Blue Star, Daikin & more</span>
                        </div>
                        <a href="tel:8879552122" className={classes.bookButton}>Book Service</a>
                    </div>

                    <div className={classes.serviceCard}>
                        <div className={classes.serviceIcon}>🎵</div>
                        <h2>Music System Repair</h2>
                        <p className={classes.serviceDescription}>
                            Professional music system repair services for home theaters, speakers, and amplifiers.
                        </p>
                        <ul className={classes.serviceFeatures}>
                            <li>Sound issues repair</li>
                            <li>Amplifier and speaker repair</li>
                            <li>Connectivity issues repair</li>
                            <li>Software update and installation</li>
                            <li>Power problems solution</li>
                        </ul>
                        <div className={classes.serviceBrands}>
                            <h4>Brands We Service:</h4>
                            <span>Philips, Sony, JBL, Bose, Yamaha, Pioneer & more</span>
                        </div>
                        <a href="tel:8879552122" className={classes.bookButton}>Book Service</a>
                    </div>
                </div>

                <section className={classes.process}>
                    <h2 className={classes.sectionTitle}>Our Service Process</h2>
                    <div className={classes.processGrid}>
                        <div className={classes.processStep}>
                            <div className={classes.stepNumber}>1</div>
                            <h3>Book Service</h3>
                            <p>Call us or fill the contact form to schedule your service appointment</p>
                        </div>
                        <div className={classes.processStep}>
                            <div className={classes.stepNumber}>2</div>
                            <h3>Expert Diagnosis</h3>
                            <p>Our technician visits and diagnoses the appliance issue thoroughly</p>
                        </div>
                        <div className={classes.processStep}>
                            <div className={classes.stepNumber}>3</div>
                            <h3>Quality Repair</h3>
                            <p>We repair your appliance using genuine spare parts and advanced tools</p>
                        </div>
                        <div className={classes.processStep}>
                            <div className={classes.stepNumber}>4</div>
                            <h3>Service Guarantee</h3>
                            <p>Enjoy reliable performance with our service warranty and support</p>
                        </div>
                    </div>
                </section>

                <section className={classes.whyChoose}>
                    <h2 className={classes.sectionTitle}>Why Choose EmpireService?</h2>
                    <div className={classes.featuresGrid}>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>⚡</div>
                            <h3>30-Minute Response</h3>
                            <p>Quick doorstep service within 30 minutes across Mumbai</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🔧</div>
                            <h3>Expert Technicians</h3>
                            <p>15+ years experienced professionals for all appliance types</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>💰</div>
                            <h3>Affordable Pricing</h3>
                            <p>Transparent and competitive rates with no hidden charges</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🛡️</div>
                            <h3>Service Warranty</h3>
                            <p>30-90 days warranty on all repair services and parts</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🕒</div>
                            <h3>24/7 Availability</h3>
                            <p>Round-the-clock service including emergency repairs</p>
                        </div>
                        <div className={classes.featureItem}>
                            <div className={classes.featureIcon}>🎯</div>
                            <h3>Genuine Parts</h3>
                            <p>Only authentic spare parts for long-lasting repairs</p>
                        </div>
                    </div>
                </section>

                <section className={classes.emergency}>
                    <h2>Need Emergency Service?</h2>
                    <p>
                        For urgent appliance repair needs, call us directly at 
                        <a href="tel:8879552122" className={classes.emergencyNumber}> +91 8879552122</a>
                    </p>
                    <p>We provide 24/7 emergency repair services across Mumbai with same-day visit guarantee.</p>
                    <a href="tel:8879552122" className={classes.emergencyButton}>Call Now</a>
                </section>
            </div>
        </div>
    );
};

export default Service;